import { render, staticRenderFns } from "./DutyManagementReports.vue?vue&type=template&id=3018f8c3"
import script from "./DutyManagementReports.vue?vue&type=script&lang=js"
export * from "./DutyManagementReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports